export const hasOrderStatus = (
  currentStatus: string | undefined,
  statusesAllowed: string[],
  additionalCondition: boolean = true
): boolean => {
  return statusesAllowed.includes(currentStatus || "") && additionalCondition;
};